import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

import { baseCss } from './css.js';
const nlSelectCss = baseCss;

const NlSelectStyle0 = nlSelectCss;

const NlSelect = /*@__PURE__*/ proxyCustomElement(class NlSelect extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.selectDomain = createEvent(this, "selectDomain", 7);
        this.isOpen = false;
        this.value = null;
        this.options = undefined;
        this.selected = undefined;
        this.mode = false;
        this.darkMode = false;
        this.themeState = 'default';
        this.theme = 'default';
    }
    handleWindowClick() {
        if (this.wrapperRef.querySelector('.listClass')) {
            this.isOpen = false;
        }
    }
    toggleDropdown() {
        this.isOpen = !this.isOpen;
        this.calculateDropdownPosition();
    }
    watchPropHandler(newValue) {
        this.themeState = newValue;
    }
    watchModeHandler(newValue) {
        this.mode = newValue;
    }
    connectedCallback() {
        this.themeState = this.theme;
        this.mode = this.darkMode;
        this.value = this.options[this.selected];
        this.selectDomain.emit(this.value.value);
    }
    calculateDropdownPosition() {
        if (this.isOpen && this.buttonRef) {
            const buttonRect = this.buttonRef.getBoundingClientRect();
            this.ulRef.style.top = `${buttonRect.height}px`;
        }
    }
    handleChange(el) {
        this.value = el;
        this.isOpen = false;
        this.selectDomain.emit(this.value.value);
    }
    render() {
        const listClass = `${this.isOpen ? 'listClass' : 'hidden'} min-w-[15rem] nl-select-list absolute left-0 shadow-md rounded-lg p-2 mt-1 after:h-4 after:absolute after:-bottom-4 after:start-0 after:w-full before:h-4 before:absolute before:-top-4 before:start-0 before:w-full`;
        const arrowClass = `${this.isOpen ? 'rotate-180' : 'rotate-0'} duration-300 flex-shrink-0 w-4 h-4 text-gray-500`;
        return (h("div", { key: 'c86084c50712455e04682a4392e490bc0e20eb1d', class: `theme-${this.themeState}` }, h("div", { key: 'a90d9b4af52845a9971c39cec69c13493d511381', class: "relative", ref: el => (this.wrapperRef = el) }, h("button", { key: '1391137997bf8fcd0a5466cd9fa20c79b4ce27ba', ref: el => (this.buttonRef = el), onClick: () => this.toggleDropdown(), type: "button", class: "nl-select peer py-3 px-4 flex items-center w-full justify-between border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent" }, h("span", { key: '224425ab92ba3599595924972e98a0fc9cb1a189', class: "truncate overflow-hidden" }, this.value.name), h("svg", { key: '8eb2a2b552cb9ea36fb1abc61d804efb423afda6', class: arrowClass, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { key: 'feea1a7f54f4a111b7bf01e3945445311b97ab82', d: "m6 9 6 6 6-6" }))), h("ul", { key: 'fca4982f04f4133d5c2a2f613a7e7d977dd5c241', ref: el => (this.ulRef = el), class: listClass }, this.options.map(el => {
            return (h("li", { onClick: () => this.handleChange(el), class: "nl-select-option flex cursor-pointer items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm" }, el.name));
        })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "theme": ["watchPropHandler"],
        "darkMode": ["watchModeHandler"]
    }; }
    static get style() { return NlSelectStyle0; }
}, [0, "nl-select", {
        "options": [16],
        "selected": [2],
        "darkMode": [4, "dark-mode"],
        "theme": [1],
        "isOpen": [32],
        "value": [32],
        "mode": [32],
        "themeState": [32]
    }, [[8, "click", "handleWindowClick"]], {
        "theme": ["watchPropHandler"],
        "darkMode": ["watchModeHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-select"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSelect);
            }
            break;
    } });
}
defineCustomElement();

export { NlSelect as N, defineCustomElement as d };

//# sourceMappingURL=nl-select2.js.map